import { useMemo } from 'react';
import { DeviceProvider as SeagullDeviceProvider, useDevice } from 'seagull';
import { useFeatureFlags } from "../hooks/useFeatureFlags";
import { jsx as _jsx } from "react/jsx-runtime";
export function DeviceProvider(_ref) {
  let {
    children,
    isMobileDevice
  } = _ref;
  const {
    MOBILE_RESPONSIVENESS = false,
    AGREEMENT_STUDIO_MOBILE = false
  } = useFeatureFlags();
  const value = useMemo(() => ({
    isMobileDeviceOLD: isMobileDevice,
    isMobileDevice: (MOBILE_RESPONSIVENESS || AGREEMENT_STUDIO_MOBILE) && isMobileDevice
  }), [isMobileDevice, MOBILE_RESPONSIVENESS, AGREEMENT_STUDIO_MOBILE]);
  return /*#__PURE__*/_jsx(SeagullDeviceProvider, {
    value: value,
    children: children
  });
}
export const useMobileResponsiveness = () => {
  const {
    MOBILE_RESPONSIVENESS = false
  } = useFeatureFlags();
  const {
    isMobileDeviceOLD
  } = useDevice();
  return {
    isMobileDevice: MOBILE_RESPONSIVENESS && isMobileDeviceOLD
  };
};
export const useAgreementStudioMobile = () => {
  const {
    AGREEMENT_STUDIO_MOBILE = false
  } = useFeatureFlags();
  const {
    isMobileDeviceOLD
  } = useDevice();
  return {
    isMobileDevice: AGREEMENT_STUDIO_MOBILE && isMobileDeviceOLD
  };
};